import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23215520"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "advantages" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Mehr als 500.000 Kunden nutzen monatlich die Immobilienbewertung der AVIV Group. Zu AVIV gehören europäische Immobilienportale wie Immowelt (Deutschland), Immoweb (Belgien) und SeLoger (Frankreich). Die Immobilienbewertung basiert auf einen Algorithmus der AVIV Group ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Informationen zur Berechnung der Schätzwerte findest du hier")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Berechnungsgrundlage für die angezeigten Immobilienwerte sind die auf immowelt.de angebotenen Immobilien. Um eine möglichst genaue Schätzung auf Basis von Lage, Größe und Alter der Immobilie abzugeben, werden bewährte statistiche Verfahren verwendet. Außerdem fließen sozioökonomische Daten in die Erhebung, z.B. die Kaufkraft im ausgewählten Gebiet. Objekte mit Preisausschlägen nach oben oder unten werden nicht berücksichtigt. Die Immobilienwerte werden monatlich aktualisiert. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Die Werte sind Schätzwerte und stellen keine rechtsverbindlichen Marktwerte dar. Der exakte Wert einer Immobilie unter Berücksichtigunug aller Bersonderheiten kann nur vor Ort ermittelt werden. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sd_link = _resolveComponent("sd-link")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_sd_modal = _resolveComponent("sd-modal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_info_box, {
      iconType: "home_valid",
      title: "500.000+ Kunden monatlich"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _hoisted_2,
          _createVNode(_component_sd_link, {
            href: "#",
            class: "read-more",
            inline: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isModalVisible = true), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _hoisted_4
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_sd_modal, {
      show: _ctx.isModalVisible,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      class: "modal",
      ref: "modal",
      "full-page": _ctx.isMobile,
      "close-button": ""
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }, 8, ["show", "full-page"])
  ]))
}